import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../components/Icon';
import { PrItem } from './PrItem';
export const resolveRepositoryData = (repos, repositoriesSlugs, repositoryId, repository) => {
    if (repository) {
        return repository;
    }
    if (!Object.keys(repos).length) {
        throw new Error('Missing list of repositories');
    }
    if (!repositoryId) {
        throw new Error('Missing repositoryId');
    }
    return repos[repositoriesSlugs[repositoryId]];
};
export const PrList = (props) => {
    const { gha, title, loading, pullRequestList, repository, repos, repositoriesSlugs, onRegisterRepo } = props;
    const { pullRequests } = pullRequestList;
    const { t } = useTranslation();
    const loadingElement = _jsxs("p", { className: 'text-center mt-4', children: [_jsx(Icon, { name: 'spinner', size: '2x', spin: true, fixedWidth: true, pulse: true }), _jsxs("span", { className: 'sr-only', children: [t('loading'), "..."] })] });
    return _jsxs("ul", { className: 'pr-list pr-3 pl-3', children: [_jsxs("li", { className: 'pr-list__item pr-list__item--header', children: [_jsx("span", { className: 'pr-list__col', children: title }), _jsx("span", { className: 'pr-list__col col-3 col-md-2', children: t('cycleTime') }), _jsx("span", { className: 'pr-list__col col-3 col-md-2 d-none d-md-flex', children: t('codeQuality') })] }), loading ? loadingElement : pullRequests.map((pullRequest) => {
                const repositoryData = resolveRepositoryData(repos, repositoriesSlugs, pullRequest.repositoryId, repository);
                return _jsx(PrItem, { gha: gha, loading: loading, repository: repositoryData, pullRequest: pullRequest, onRegisterRepo: onRegisterRepo }, pullRequest.id);
            })] });
};
